export enum QuestionType {
  Radio = 'Question-Radio',
  Input = 'Question-Input',
  Select = 'Question-Select',
  MultiSelectButton = 'Question-MultiSelectButton',
  Hidden = 'Question-Hidden',
  Income = 'Question-Income',
  Checkbox = 'Question-Checkbox',
  StateSelect = 'Question-StateSelect',
  MultiButton = 'Question-MultiButton',
  Demographics = 'Question-Demographics',
  BinaryButton = 'Question-BinaryButton',
  CheckboxMulti = 'Question-CheckboxMulti',
  LanguagePreference = 'Question-Language',
  QuestionGroup = 'Question-QuestionGroup',
  CreateAccount = 'Question-CreateAccount',
  RateSelection = 'Question-RateSelection',
  NTLRateSelection = 'Question-NTLRateSelection',
  CompareLERateSelection = 'Question-CompareLERateSelection',
  AddressAutoComplete = 'Question-AddressAutoComplete',
  AddressFieldsAutoComplete = 'Question-AddressFieldsAutoComplete',
  RepeatableQuestionGroup = 'Question-RepeatableQuestionGroup',
  APICallLoader = 'Question-APICallLoader',
  Uploader = 'Question-Uploader',
  InfoAccordion = 'Question-InfoAccordion',
  SSN = 'Question-SSN',
  PlaidAssets = 'Question-PlaidAssets',
  AmazonBenefits = 'Question-AmazonBenefits',
  Toggle = 'Question-Toggle',
  AUSResults = 'Question-AUSResults',
  FinicityLink = 'Question-FinicityLink',
  SSNPage = 'Question-SSNPage',
  HomeEquityOfferSelection = 'Question-HomeEquityOfferSelection',
  SimpleSuccess = 'question_simple_v2_success',
  LoanOfficerIntro = 'Question-LoanOfficerIntro',
  SimpleV2Info = 'question_simple_v2_info',
  SimpleV2PlaidIntro = 'question_simple_v2_plaid_intro',
  SimpleV2Offramp = 'question_simple_v2_offramp',
  SimpleV2DownPayment = 'question_simple_v2_down_payment',
  SimpleV2Declarations = 'question_simple_v2_declarations',
  SimpleV2CreditLoad = 'question_simple_v2_credit_load',
  SimpleV2FannieLoaders = 'question_simple_v2_fannie_loaders',
  SimpleV2PricingLoad = 'question_simple_v2_pricing_load',
  SimpleV2OfframpSuccess = 'question_simple_v2_offramp_success',
  SimpleV2OfframpFailed = 'question_simple_v2_offramp_failed',
  SimpleV2AddressFields = 'question_simple_v2_address_fields',
  SimpleV2ResidencyHistory = 'question_simple_v2_residency_history',
  SimpleV2EmploymentHistory = 'question_simple_v2_employment_history',
  SimpleV2CoBorrowerQuestion = 'question_simple_v2_co_borrower_question',
  SimpleV2IncomeAssignment = 'question_simple_v2_income_assignment',
  SimpleV2CoBorrowerDeclarations = 'question_simple_v2_co_borrower_declarations',
  SimpleV2CoBorrowerSsnTask = 'question_simple_v2_co_borrower_ssn_task',
}
